import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function Ten99PolicyShiftCoverageCard() {
  const { shiftId } = useShiftModalsDataContext();
  const { userId: workerId } = useDefinedWorker();

  useLogEffect(APP_V2_USER_EVENTS.VIEWED_TEN99_POLICY_COVERAGE_CARD, {
    shiftId,
    workerId,
  });

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="success"
      title="Your shifts at this workplace are covered by Workers' Compensation"
      description="You'll contribute a small percentage of your earnings toward coverage."
      illustrationType="shift-protection"
    />
  );
}
